let Component1 = {
    init: function () {
       console.log('loaded component 1')
    },
    tireDetail: function() {
    	let promo = { 
			"CouponId": "8", 
			"Description": "Purchase 3 Autogrip ECOWINTER Tire, get the 4th free", 
			"Name": "Buy 3 Get 1", 
			"SortOrder": "3", 
			"TireSKUNumber": "780554350",
			"RuleID": "2"
		};

    	let postData = {
    		"qty": "4",
    		"sku": "407285374",
    		"tirebrand": "goodyear",
    		"promotion": JSON.stringify(promo)
    	};

    	console.log(postData);

	    var postFormStr = "<form method='POST' accept-charset='UTF-8' action='" + window.location.origin + '/tire-search/detail' + "'>\n";

	    for (var key in postData)
	    {
	        if (postData.hasOwnProperty(key))
	        {
	            postFormStr += "<input type='hidden' name='" + key + "' value='" + postData[key] + "'></input>";
	        }
	    }

	    postFormStr += "</form>";

	    var formElement = jQuery(postFormStr);

	    jQuery('body').append(formElement);
	    jQuery(formElement).submit();
    },

    sendEmail: function(){
        let tireInfo = {

        };

        jQuery.ajax({
            url: window.location.origin + '/wp-json/monro/v1/email/tire-quote',
            type: 'POST',
            data: {
                to: ['andrew.vogler@eagledream.com'],
                subject: '{{brandName}} Price Quote',
                template: 'tire-quote',
                firstName: 'first testing',
                lastName: 'testing last',
                email: 'test@monro.com',
                storeId: 10,
                tireInfo: JSON.stringify(tireInfo)
            },
            success: function(response){
                console.log(response);
                console.log('Sent Message');
            },
            error: function(response){
                console.log(response);
            }
        });
    }
};